import { deleteData, getData, postData, putData } from "../Config/AxiosConfig"


export const addFranchise = async (body) => {
    return await postData('franchise', body)
}

export const updateFranchiseStatus = async (id, body) => {
    return await putData(`franchise/${id}`, body)
}

export const updateFranchise = async (id, body) => {
    return await putData(`update-franchise/${id}`, body)
}

export const deleteFranchise = async (id) => {
    return await deleteData(`delete-franchise/${id}`)
}


export const getFranchise = async () => {
    return await getData('franchise')
}
